// extracted by mini-css-extract-plugin
module.exports = {"pageFooter":"XxxQuestionsPage_pageFooter__22Qw2","pageNavigationPanel":"XxxQuestionsPage_pageNavigationPanel__1riIJ"};